<script setup lang="ts">
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';
import {useI18n} from 'vue-i18n';
import {computed} from 'vue';
import {useRoute} from 'vue-router';

const {t: $t} = useI18n();
const route = useRoute();

const isPublicPage = computed(() => {
  return route.path.includes('/public/');
});
</script>

<template>
  <div
    class="allianz-branding-footer"
    :class="{'allianz-branding-footer--public': isPublicPage}"
  >
    <div class="branding-content">
      <p class="branding-text">
        {{ $t('made_possible_by') }}
      </p>
      <svg-illustration
        name="partner-logo-allianz.svg"
        class="allianz-logo"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.allianz-branding-footer {
  display: flex;
  justify-content: flex-end;
  pointer-events: none;
  color: var(--Allianz-branding);
  margin-top: auto;
  margin-bottom: var(--Spacing-spacing-5);
  padding-right: var(--Spacing-spacing-5);
  padding-top: var(--Spacing-spacing-6);
  width: 100%;

  &--public {
    @include screen-md {
      padding-right: var(--Spacing-spacing-10);
    }
  }
}

.branding-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;

  @include screen-md {
    gap: 6px;
  }
}

.branding-text {
  font-family: "Allianz", serif;
  font-size: 10px;
  line-height: 1.2;
  margin: 0;
  text-align: left;

  @include screen-md {
    font-size: 14px;
  }
}

.allianz-logo {
  width: 97px;
  height: auto;

  @include screen-md {
    width: 161px;
  }

  :deep(svg) {
    color: inherit;
  }
}
</style>
